export class AlarmLog {
    tm: number;
    seq: number;
    tm_date: string;
    tm_time: string;
    event: string;
    text: string;
    deal: string;
    alid: string;
    evnr: number;
    area: string;
    comm_gen: string;
    s_cam: number;
    zoneid: string;
    misc10: string;
    misc6: string;
    misc7: string;
    misc8: string;

    constructor() {
        this.tm = 0;
        this.seq = 0;
        this.tm_date = '';
        this.tm_time = '';
        this.event = '';
        this.text = '';
        this.deal = '';
        this.alid = '';
        this.evnr = 0;
        this.area = '';
        this.comm_gen = '';
        this.s_cam = 0;
        this.zoneid = '';
        this.misc10 = '';
        this.misc6 = '';
        this.misc7 = '';
        this.misc8 = '';
    }
}